const th = {
    CommunicationServices: "บริการด้านการสื่อสาร",
    ConsumerDefensive: "สาธารณูปโภคพื้นฐาน",
    Energy: "พลังงาน",
    Healthcare: "การแพทย์",
    RealEstate: "อสังหาริมทรัพย์",
    BasicMaterials: "วัสดุทั่วไป",
    ConsumerCyclical: "สินค้าฟุ่มเฟือย/ตามวัฏจักร",
    FinancialServices: "บริการด้านการเงิน",
    Industrials: "อุตสาหกรรม",
    Technology: "เทคโนโลยี",
    Utilities: "อรรถประโยชน์",
    PreferredNet: "บุริมสิทธิ",
    StockNet: "ตราสารทุน",
    BondNet: "ตราสารหนี้",
    CashNet: "เงินสด/เงินฝาก",
    ConvertibleNet: "หุ้นกู้แปลงสภาพ",
    OtherNet: "อื่นๆ"
}

export default {
    th
}